import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";

const links = [];

export const Nav = ({ onReserveClick }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => {
        setScrolled(window.scrollY > 12);
        ticking = false;
      });
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-[padding] duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div
          className={`flex items-center justify-between rounded-lg px-4 md:px-6 py-3 transition-[background-color,border-color] duration-500 ${
            scrolled
              ? "glass-card"
              : "border border-transparent"
          }`}
        >
          <a
            href="#top"
            data-testid="nav-logo"
            className="flex items-center gap-3 group"
          >
            <img
              src="/w-logo-navy.png"
              alt="W"
              width={40}
              height={40}
              decoding="async"
              fetchPriority="high"
              className="h-10 w-10 object-contain dark:hidden"
              data-testid="nav-logo"
            />
            <img
              src="/w-logo.png"
              alt=""
              aria-hidden="true"
              width={40}
              height={40}
              decoding="async"
              className="h-10 w-10 object-contain hidden dark:block invert"
            />
          </a>

          <nav className="hidden md:flex items-center gap-7" aria-label="Primary">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-[13px] tracking-wide text-ash hover:text-pearl transition-colors duration-300"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <button
            data-testid="nav-reserve-btn"
            onClick={onReserveClick}
            className="group inline-flex items-center gap-2 rounded-lg bg-[#1E3A5F] text-white px-4 py-2 text-[12px] font-medium tracking-wide hover:bg-[#2A4A75] transition-colors duration-300"
          >
            Reserve handle
            <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Nav;
